

import {
  mdiArrowRightBold,
  mdiDelete,
  mdiMenuRight,
  mdiMenuDown,
  mdiArrowLeft,
  mdiMapMarker,
  mdiTooltipAccount,
  mdiPlus,
  mdiLogout,
  mdiCheckboxMarkedOutline,
  mdiCheckboxBlankOutline,
  mdiMagnify,
  mdiContentSaveOutline,
  mdiChevronUp,
  mdiClose,
  mdiBottleWine,
  mdiDownload,
  mdiGrid,
  mdiFormatListBulleted,
  mdiPlusBoxOutline,
  mdiMinusBoxOutline,
  mdiPencilOutline,
  mdiNumeric,
  mdiInformationOutline,
  mdiCalendar
} from '@mdi/js'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class IconsMixin extends Vue {
  public iconArrowRight = mdiArrowRightBold
  public iconDeleteIcon = mdiDelete
  public iconMenuRight = mdiMenuRight
  public iconMenuDown = mdiMenuDown
  public iconBackScreen = mdiArrowLeft
  public iconMapMarker = mdiMapMarker
  public iconDriverMarker = mdiTooltipAccount
  public iconAddLoad = mdiPlus
  public iconLogOut = mdiLogout
  public iconCheckboxChecked = mdiCheckboxMarkedOutline
  public iconCheckboxUnchecked = mdiCheckboxBlankOutline
  public iconMagnify = mdiMagnify
  public iconSave = mdiContentSaveOutline
  public iconChevronUp = mdiChevronUp
  public iconClose = mdiClose
  public iconBottleWine = mdiBottleWine
  public iconDownload = mdiDownload
  public iconGrid = mdiGrid
  public iconFormatListBulleted = mdiFormatListBulleted
  public iconPlusBoxOutline = mdiPlusBoxOutline
  public iconMinusBoxOutline = mdiMinusBoxOutline
  public iconPencilOutline = mdiPencilOutline
  public iconNumeric = mdiNumeric
  public iconInformation = mdiInformationOutline
  public iconCalendar = mdiCalendar
}

